let active = false
let body = document.body
let buttonOffset = 59
let buttonEl = document.querySelector('.js-photodrag-button')
let wrapperEl = document.querySelector('.js-photodrag')
let beforeEl = document.querySelector('.js-photodrag-before')

function init(){
	buttonEl.addEventListener('mousedown',function(){
		active = true
		buttonEl.classList.add('grabbing')
	})

	body.addEventListener('mouseup',function(){
		active = false
		buttonEl.classList.remove('grabbing')
	})
	body.addEventListener('mouseleave',function(){
		active = false
		buttonEl.classList.remove('grabbing')
	})

	body.addEventListener('mousemove',function(e){
		if (!active) return

		let x = e.pageX
		x -= wrapperEl.getBoundingClientRect().left

		if (x <= 0){
			buttonEl.classList.add('start')
		}else {
			buttonEl.classList.remove('start')
		}

		scrollIt(x)
	})

	function scrollIt(x){
			let transform = Math.max(0,(Math.min(x,wrapperEl.offsetWidth)))
			beforeEl.style.width = transform+"px"
			buttonEl.style.left = transform - buttonOffset+"px"
	}

	scrollIt(200)

	// Touch
	buttonEl.addEventListener('touchmove',function(e){

		let x = e.touches[0].clientX
		x -= wrapperEl.getBoundingClientRect().left

		scrollIt(x)
	})
}

if (buttonEl) {
	init()
}
